export default __webpack_public_path__ + "static/media/L_Lapis.5030eabd.svg";